import { Link, useLoaderData } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { client } from '../api/client'
import './House.css'

const reflections = [
  {text:'真正的发现，不是看见新的风景，而是拥有新的眼睛。',note:'换一个观察角度，熟悉的页面也会显露秘密。'},
  {text:'路走错了，也会遇见路。',note:'每一次试探都在缩小未知的边界。'},
  {text:'答案会过期，寻找答案的能力不会。',note:'把好奇心练成习惯，它会带你走得更远。'},
  {text:'所谓成长，是把“我不会”变成“我可以试试”。',note:'先动手，再让反馈告诉你下一步。'},
  {text:'看见表象是本能，看见结构是能力。',note:'慢一点观察，问一问：它为什么会这样？'},
  {text:'不怕问题复杂，只怕问题没有被看见。',note:'清楚地描述问题，往往已经解决了一半。'},
  {text:'山不向你走来，你便向山走去。',note:'主动探索的人，总能比答案更早抵达。'},
  {text:'微小的坚持，会在时间里长成答案。',note:'今天多理解一个细节，明天就少一分慌张。'},
  {text:'勇气不是没有困惑，而是带着困惑继续前行。',note:'允许暂时不懂，但不要停止追问。'},
  {text:'知识告诉你门在哪里，实践教会你怎样打开。',note:'亲手验证，才会把别人的结论变成自己的能力。'},
  {text:'你所寻找的线索，也正在塑造寻找它的你。',note:'耐心、专注与判断力，都是探索留下的礼物。'},
  {text:'一次失败，只是世界告诉你：换一种方法。',note:'记录过程，调整假设，然后再试一次。'},
  {text:'理解一件事最好的方式，是让它在你手中发生。',note:'观察、操作、验证，再把规律说给自己听。'},
  {text:'所有笃定，都曾经是一次小心翼翼的尝试。',note:'不要轻视开始时那一点点进步。'},
  {text:'保持清醒，也保持热望。',note:'理性帮你辨认方向，热爱让你愿意走完全程。'},
  {text:'走得慢没有关系，只要每一步都让你更接近真实。',note:'速度不等于成长，理解才是。'},
  {text:'好的问题像一束光，使复杂的世界出现轮廓。',note:'先问对问题，再寻找精确的证据。'},
  {text:'别急着证明自己，先让事实说话。',note:'证据、复现与推理，会给你更可靠的自信。'},
  {text:'你今天认真查过的细节，会成为未来从容的底气。',note:'专业感，往往藏在别人忽略的小地方。'},
  {text:'世界奖励那些愿意多看一层的人。',note:'页面之外还有请求、存储、脚本与状态。'}
]

const pickReflection = previous => {
  if (reflections.length === 1) return reflections[0]
  let next = reflections[Math.floor(Math.random()*reflections.length)]
  while (next === previous) next = reflections[Math.floor(Math.random()*reflections.length)]
  return next
}

export async function loader({params}) {
  const {data} = await client.get('/api/teams/'+encodeURIComponent(params.team))
  if (!data.members.length) throw new Response('未找到战队',{status:404})
  return data
}
export default function HousePage() {
  const param=useLoaderData()
  const {user}=useSelector(state=>state.user)
  const [pressed,setPressed]=useState(false)
  const [reflection,setReflection]=useState(()=>pickReflection())
  const isHome=user.team===param.team
  useEffect(()=>{
    window.render_game_to_text = () => JSON.stringify({
      scene:'house',
      isHome,
      occupants:param.members.map(member=>member.sid),
      reflection:reflection.text,
      secretControlVisible:isHome,
      secretControlActivated:pressed,
      note:'页面坐标原点在左上角，x向右、y向下。'
    })
    window.advanceTime = () => {}
    return () => {
      delete window.render_game_to_text
      delete window.advanceTime
    }
  },[isHome,param.members,pressed,reflection])
  return <div className="house-page-container">
    <header className="house-nav"><Link to="/">← 回到门厅</Link><span>HOUSE OF GROWTH</span></header>
    <main className="house-main">
      <section className="house-welcome">
        <p className="house-kicker">{isHome?'THE DOOR REMEMBERS YOU':'A ROOM ALONG THE WAY'}</p>
        <h1>{isHome?'欢迎回家':'既然来了，就坐一会儿'}</h1>
        <p>{isHome?'你们找到了属于自己的门。真正重要的线索，常常藏在一次亲手触发的请求里。':'这不是你们的家，但走错的路也可以有风景。带一句话再继续寻找吧。'}</p>
      </section>

      <section className="reflection-card" aria-live="polite">
        <span className="quote-mark">“</span>
        <blockquote>{reflection.text}</blockquote>
        <p>{reflection.note}</p>
        <button onClick={()=>setReflection(current=>pickReflection(current))}>再读一句</button>
      </section>

      <section className="house-owners">
        <p className="section-label">屋主人</p>
        <div className="owner-list">{param.members.map(s=><div className="owner" key={s.sid}><span>{s.name.slice(0,1)}</span><div><strong>{s.name}</strong><small>{s.sid}</small></div></div>)}</div>
      </section>

      {isHome&&<section className="house-secret">
        <div><p className="section-label">只属于归家者的机关</p><h2>终于找到了。</h2><p>点击按钮，然后留意浏览器与服务器之间发生了什么。</p></div>
        <button disabled={pressed} onClick={()=>client.get('/getd?t='+user.team).then(()=>setPressed(true)).catch(e=>alert(e))}>{pressed?'机关已经启动':'对，就是我'}</button>
      </section>}
    </main>
  </div>
}
